"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = __importDefault(require("@graphql-mesh/graphql"));
class ContentfulHandler extends graphql_1.default {
    constructor({ name, config, cache, pubsub }) {
        config.schemaHeaders = config.operationHeaders = {
            authorization: `Bearer ${config.token}`,
        };
        if (!config.endpoint) {
            config.endpoint = `https://graphql.contentful.com/content/v1/spaces/${config.space}/environments/${config.environment || 'master'}`;
        }
        super({ name, config, cache, pubsub });
    }
}
exports.default = ContentfulHandler;
//# sourceMappingURL=handler.js.map